import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const PageStyles = styled.section`
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 2rem 0;
`;

export const PageHeader = styled.div`
  text-align: center;
  margin-bottom: 2rem;

  h2 {
    color: #2c3e50;
    font-weight: 700;
    font-size: 1.7rem;
    margin: 0;
    
    @media (max-width: 768px) {
      font-size: 1.5rem;
    }
  }
`;

export const AfterSaleCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 1rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  &:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
    transform: translateY(-2px);
  }

  @media (min-width: 576px) {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
`;

export const CardContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const CustomerName = styled.div`
  font-weight: 700;
  color: #2c3e50;
  font-size: 1.1rem;
  margin-bottom: 0.25rem;
`;

export const InfoChip = styled.p`
  margin: 0;
  color: #555;
  font-size: 0.95rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;

  strong {
    color: #2c3e50;
  }

  .icon {
    font-size: 0.9rem;
  }
`;

export const DateInfo = styled.small`
  color: #7f8c8d;
  font-size: 0.85rem;
  
  strong {
    font-weight: 600;
  }
`;

export const CardActions = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.75rem;
  align-items: center;
  flex-wrap: wrap;

  @media (min-width: 576px) {
    align-items: center;
  }
`;

export const StatusBadge = styled.span`
  background: #343a40;
  color: white;
  padding: 0.25rem 0.5rem;
  border-radius: 1.25rem;
  font-size: 0.875rem;
  font-weight: 400;
  display: inline-block;
`;

export const ActionButton = styled(Link)`
  background: #198754;
  color: white;
  padding: 0.25rem 0.75rem;
  border-radius: 1.25rem;
  text-decoration: none;
  font-weight: 400;
  display: inline-block;

  &:hover {
    background: #157347;
    color: white;
  }
`;

export const LoadingState = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 3rem;
  gap: 1rem;

  .spinner-border {
    width: 3rem;
    height: 3rem;
    color: #667eea;
  }

  span {
    color: #555;
    font-size: 1rem;
  }
`;

export const EmptyState = styled.div`
  background: white;
  border-radius: 12px;
  padding: 3rem 2rem;
  text-align: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  .fw-bold {
    color: #7f8c8d;
    font-size: 1.1rem;
    font-weight: 600;
  }
`;
